function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramBlack = function SvgInstagramBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.979 67.534h48.042A8.083 8.083 0 0 0 67 59.386V10.558a8.034 8.034 0 0 0-7.979-8.092H10.979A8.034 8.034 0 0 0 3 10.558v48.828a8.083 8.083 0 0 0 7.979 8.148Zm44-59.168a5.338 5.338 0 1 1-5.341 5.334 5.335 5.335 0 0 1 5.337-5.334Zm-20 9.946A16.69 16.69 0 1 1 18.565 35a16.535 16.535 0 0 1 16.407-16.688Z",
    style: {
      fill: "#1c1c1c"
    }
  }));
};
export default SvgInstagramBlack;